import {Directive, ElementRef, inject} from '@angular/core';

@Directive({
  selector: '[mxCarouselItem]'
})
export class CarouselItemDirective {
  public readonly element: HTMLElement = inject(ElementRef).nativeElement;
}
